import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  children: React.ReactNode;
  showArrow?: boolean;
}
export function Button({
  variant = 'primary',
  children,
  showArrow = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center px-8 py-4 font-sans font-semibold tracking-wide transition-all duration-300 overflow-hidden group';
  const variants = {
    primary: 'bg-gold-gradient text-navy-950 hover:shadow-[0_0_30px_rgba(212,175,55,0.3)]',
    secondary: 'bg-transparent text-gold-400 border border-gold-500/30 hover:border-gold-400 hover:bg-gold-500/5'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-225">
      {/* Subtle shine effect on primary button */}
      {variant === 'primary' && <div className="absolute inset-0 -translate-x-full bg-white/20 skew-x-12 group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-226" />}

      <span className="relative flex items-center gap-2" data-id="element-227">
        {children}
        {showArrow && <ChevronRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-228" />}
      </span>
    </motion.button>;
}